import axios from 'axios';
import qs from 'qs';
import _ from 'lodash';
import { AUTH_ERROR } from './http-error-handlers';

function validateRequestUrl(url) {
  if (!_.endsWith(url, '/')) {
    console.error(
      "Requesting URL doesn't have tracing slash. This occurs API fetch error in IOS. URL:" +
        url
    );
  }

  return url;
}

function bindInterceptors(httpInstance) {
  httpInstance.interceptors.request.use(
    config => {
      config.url = validateRequestUrl(config.url);
      return config;
    },
    error => {
      return Promise.reject(error);
    }
  );

  httpInstance.interceptors.response.use(
    async response => {
      return response;
    },
    error => {
      let errorCode = error.response.data.error_code || error.response.status;
      let expectedError = AUTH_ERROR[errorCode];

      if (expectedError) {
        return expectedError.handler(expectedError.message);
      }

      return Promise.reject(error);
    }
  );
}

const http = axios.create({
  baseURL: process.env.VUE_APP_API_ENDPOINT,
  validateStatus: function(status) {
    return status >= 200 && status < 300;
  },
  paramsSerializer: function(params) {
    return qs.stringify(params, { arrayFormat: 'repeat' });
  }
});

bindInterceptors(http);

export default http;
